import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { investorStatementFormGroup } from 'src/app/pages/investor-qualification-wizard/investor-qualification-wizard-form.helper';
import { ValidatedCheckboxComponent } from '../../common/validated-checkbox/validated-checkbox.component';

@Component({
  selector: 'app-statement-form',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    ValidatedCheckboxComponent,
  ],
  templateUrl: './statement-form.component.html',
  styleUrl: './statement-form.component.scss',
})
export class StatementFormComponent {
  public formGroup = input.required<FormGroup<investorStatementFormGroup>>();
}
